/** Integrated real-data Play preview — Slice 2.12 */

export const DEV_PREVIEW_PLAY_INTEGRATED_ROUTE_PATH = '/dev-preview/play-integrated'
export const DEV_PREVIEW_PLAY_INTEGRATED_API_BASE = '/api/dev-preview/play-integrated'

/** @deprecated Use PLAY_CONNECT_DOG_CARD_PREVIEW_WINDOW_NAME from @/lib/play/playConnectConstants */
export { PLAY_CONNECT_DOG_CARD_PREVIEW_WINDOW_NAME as INTEGRATED_PREVIEW_DOG_CARD_WINDOW_NAME } from '@/lib/play/playConnectConstants'

export const DEV_PREVIEW_PLAY_INTEGRATED_COOKIE_NAME =
  'wagamour_dev_preview_play_integrated_session'
export const DEV_PREVIEW_PLAY_INTEGRATED_COOKIE_PREFIX = 'integrated-v1:'

export const PLAY_INTEGRATED_PREVIEW_EMAIL_DOMAIN = '@test.wagamour'

export const PLAY_INTEGRATED_PREVIEW_STATES = [
  'first-friend',
  'needs-play-ready',
  'incoming-connection',
  'outbound-invitation',
  'growing-circle',
  'coordination-in-motion',
  'removed-relationship',
  'blocked-relationship',
  'multiple-pending',
] as const

export type PlayIntegratedPreviewState = (typeof PLAY_INTEGRATED_PREVIEW_STATES)[number]

export const PLAY_INTEGRATED_PREVIEW_STATE_LABELS: Record<
  PlayIntegratedPreviewState,
  string
> = {
  'first-friend': 'First friend',
  'needs-play-ready': 'Needs Play Ready',
  'incoming-connection': 'Incoming connection',
  'outbound-invitation': 'Outbound invitation',
  'growing-circle': 'Growing circle',
  'coordination-in-motion': 'Coordination in motion',
  'removed-relationship': 'Removed relationship',
  'blocked-relationship': 'Blocked relationship',
  'multiple-pending': 'Multiple pending',
}

export function parsePlayIntegratedPreviewState(
  value: string | null | undefined
): PlayIntegratedPreviewState | null {
  const v = value?.trim().toLowerCase()
  if (!v) return null
  return (PLAY_INTEGRATED_PREVIEW_STATES as readonly string[]).includes(v)
    ? (v as PlayIntegratedPreviewState)
    : null
}

export function integratedPreviewUserEmail(state: PlayIntegratedPreviewState): string {
  return `play-integrated-${state}${PLAY_INTEGRATED_PREVIEW_EMAIL_DOMAIN}`
}

export function integratedPreviewDogId(state: PlayIntegratedPreviewState): string {
  return `integrated-dog-${state}-milo`
}
